import { IContinent } from 'enhancers/withGlobalRegistrationPageData';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import styled from 'styled-components';

import RegistrationItem from './RegistrationItem';

interface IProps {
  items: IContinent[];
}

type Props = IProps & WithLanguageProps;

export const RegistrationTable: React.SFC<Props> = props => {
  return (
    <Container>
      {props.items.map((item, i) => {
        return (
          <Item
            key={i}
            name={props.getText(item.Name)}
            items={item.Countries}
          />
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

const Item = styled(RegistrationItem)`
  /* flex: 0 0 50%; */
  /* width: 50%; */
`;

export default withLanguageState(RegistrationTable);



// WEBPACK FOOTER //
// ./src/components/RegistrationTable/RegistrationTable.tsx